export const UPDATE_URL = 'UPDATE_URL';

export const updateURL = function(data){
	return {
	    type: UPDATE_URL,
	    data
	};
};

export const CLEAN_URL = 'CLEAN_URL';

export const cleanURL = function(data){
	return {
	    type: CLEAN_URL
	};
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/urlRouting/actions.js